import styled from "styled-components";
import Theme from '../../../../styles/Theme/Theme';

// Layout default for videowall

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: [col1] 1.3fr [col2] 4fr [col3] ${props => (props.zonaD ? '0.8fr' : null)};
  grid-template-rows: 3fr 1.2fr;
  height: 100vh;
  width: 100vw;
  background-color: #E6EDF0;
`;

export const GridWrapper = styled.div`
  background-color: ${Theme.color.neutral2};
`;

// export const ZoneA = styled.div`
//   display: grid;
//   grid-column: col1;
//   grid-row: 1 / -1;
// `;

export const ZoneB = styled.div`
  display: grid;
  grid-column: col2;
  grid-row: 1;
  /* border-radius: 12px; */
  /* margin: 8px; */
`;

export const ZoneC = styled.div`
  display: grid;
  grid-column: col2;
  grid-row: 2;
`;
